<script setup>
import ErrorPanel from 'components/ErrorPanel.vue';
import { usePageMeta } from 'composables/page-meta';
import AppRoute from 'src/router/app-route';
import { Route } from 'src/router/routes';
import { buildPageMeta } from 'src/utils/page-meta-util';

usePageMeta(buildPageMeta({
    title: 'Something Went Wrong',
    description: 'This Xprt Dev page could not be loaded. Please try again shortly.',
    robots: 'noindex,nofollow'
}));

function reloadPage() {
    window.location.reload();
}
</script>

<template>
    <ErrorPanel :status-code="500" class="unknown-error-page" reason="Something went wrong" title="This page couldn't be loaded.">
        Something failed on our side while the page was being prepared. Try again in a moment.
        <template #actions>
            <q-btn color="primary" label="Try again" no-caps unelevated @click="reloadPage"/>
            <q-btn :to="AppRoute.build(Route.Home)" color="primary" label="Go to the home page" no-caps outline/>
        </template>
    </ErrorPanel>
</template>
